// @flow

import qs from 'query-string';

export default (search) => qs.parse(search);
